import * as RulesActions from 'app/modules/rules/actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchOrgUsers } from 'app/modules/user/actions'
import { unfilteredOrgUsersByIdJS } from 'app/modules/user/selectors'
import { makeHasGate } from 'app/modules/gates/selectors'

import RulesEditorLayout from '../layouts/RulesEditor'

const salesforceIsAlreadyPresent = (rules) => {
  rules.find(rule => {
    return rule.conditions.length && rule.conditions[0].find(cond => {
      return cond.field === 'salesforceOwner'
    })
  })
}

function mapStateToProps(state) {
  const rules = state.get('rules').get('rules')
  const showSalesforceOption = !salesforceIsAlreadyPresent(rules)
  return {
    activeRule: state.get('rules').get('activeRule'),
    users: unfilteredOrgUsersByIdJS(state),
    showSalesforceOption,
    hasABM: makeHasGate('ABM')(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...RulesActions, fetchOrgUsers }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RulesEditorLayout)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/containers/RulesEditor.js